import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ActorsService {

    public static actorsUrl = 'actors';

    constructor(private httpClient: HttpClient) {
    }

    get<T>(url: string, httpParams = new HttpParams()): Observable<T> {
        return this.httpClient.get<T>(url, {params: httpParams});
    }

    post<T>(url: string, postBody: any = {}, httpParams = new HttpParams()): Observable<T> {
        return this.httpClient.post<T>(url, postBody, {params: httpParams});
    }

    put<T>(url: string, postBody: any = {}, httpParams = new HttpParams()): Observable<T> {
        return this.httpClient.put<T>(url, postBody, {params: httpParams});
    }

    delete<T>(url, httpParams = new HttpParams()): Observable<T> {
        return this.httpClient.delete<T>(url, { params: httpParams });
    }

    patch<T>(url, postBody, httpParams = new HttpParams()): Observable<T> {
        return this.httpClient.patch<T>(url, postBody,  { params: httpParams });
    }
}
